import ExcelViewer from '../ExcelViewer/ExcelViewer';
import PDFViewer from '../PDFViewer/PDFViewer';
import PPTXViewer from '../PPTXViewer/PptxViewer';
import TxtViewer from '../TXTViewer/TxtViewer';
import WordViewer from '../WordViewer/WordViewer';

const CustomViewer = ({
  url,
  onLoad = () => null,
  isExcel = false,
  isWord = false,
  isPdf = false,
  isSimpleFile = false,
  isPresentation,
  documentLoaded,
}) => {
  if (isExcel) return <ExcelViewer url={url} onLoad={onLoad} />;
  if (isWord) return <WordViewer url={url} onLoad={onLoad} />;
  if (isPdf) return <PDFViewer url={url} onLoad={onLoad} />;
  if (isPresentation)
    return <PPTXViewer link={url} documentLoaded={documentLoaded} onLoad={onLoad} />;
  if (isSimpleFile) return <TxtViewer url={url} onLoad={onLoad} />;
  return null;
};

export default CustomViewer;
